import { createTheme } from '@mui/material';
import { LicenseInfo } from '@mui/x-license';

export function initMuiConfig() {
  LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_KEY);
}

export const legacyTheme = createTheme({
  palette: {
    primary: {
      main: '#6baa00',
    },
    secondary: {
      main: '#ffeb3b',
    },
    success: {
      main: '#739e29',
    },
    info: {
      main: '#22a7f0',
      dark: '#0074FF',
    },
  },
  typography: {
    fontFamily: 'Poppins, sans-serif',
  },
});

export const newTheme = createTheme({
  typography: {
    htmlFontSize: 16, // TODO: cambiar por 18, default 16
    fontSize: 14, // TODO: cambiar por 13, default 14
    fontFamily: 'Poppins, sans-serif',
  },
  palette: {
    primary: {
      main: '#6baa00',
    },
    secondary: {
      main: '#ffeb3b',
    },
    success: {
      main: '#739e29',
    },
    info: {
      main: '#22a7f0',
      dark: '#0074FF',
    },
  },
  // spacing: 1,
});
